<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Config'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Config')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <v-btn class="accent" v-if="siteConfigChildren&&!syncInProgress" @click="syncDialog=true">
                        <v-icon small class="mr-2">fa-sitemap</v-icon>
                        {{ 'Sync config to child sites'|translate }}
                    </v-btn>
                    <config-record-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></config-record-dialog>
                    <v-dialog v-model="syncDialog" max-width="800" persistent>
                        <v-card v-if="syncDialog">
                            <v-card-title class="primary white--text title">
                                {{ 'Sync config to child sites'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <h4 class="text-center" v-if="syncInProgress">{{ 'Sync in progress. Do not close this window.'|translate }}</h4>
                                <v-select v-if="!syncInProgress" multiple v-model="thingsToSync" :items="possibleThingsToSync" :label="'Configs to sync'|translate"></v-select>
                                <v-progress-linear v-if="syncInProgress" :value="syncProgress"></v-progress-linear>
                                <p v-if="syncInProgress" class="text-center">{{ syncMessage }}</p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" :disabled="thingsToSync.length<1||syncInProgress" @click="runSyncToChildren">
                                    {{ 'Sync to all children'|translate }}
                                </v-btn>
                                <v-btn @click="syncDialog=false" :disabled="syncInProgress">{{ 'Cancel'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="config"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.config_id }}</td>
                            <td class="text-xs-left">
                                {{ props.item.config_name }}
                            </td>
                            <td class="text-xs-left">{{ props.item.facility_name }}</td>
                            <td class="text-xs-left">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Config')"
                                    @click="$can('update', 'Config') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Config')"
                                    @click="$can('update', 'Config') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                    <p v-if="frontendVersion" class="mt-2">
                        Version : {{ frontendVersion }}
                    </p>
                    <p v-if="apiBaseURL" class="mt-2">
                        API URL : {{ apiBaseURL }}
                    </p>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getConfig, deleteConfig, getFacilityList, putConfig, putCustomView, getRule, putRule} from '../helper'
import ConfigRecordDialog from '../components/config/ConfigRecordDialog'
import {mapGetters} from "vuex";
import moment from "moment/moment";

export default {
    name: 'Config',
    components: {ConfigRecordDialog},
    data() {
        return {
            dialog: false,
            syncDialog: false,
            syncProgress: 0,
            syncMessage: null,
            syncInProgress: false,
            possibleThingsToSync:["menuConfig","customViews","rules","mappingIntegrityConfig","mappingCalculatedConfig","mappingRefConfig"],
            thingsToSync:[],
            headers: [
                {
                    text: this.$options.filters.translate('Config ID'),
                    align: 'left',
                    sortable: true,
                    value: 'config_id',
                },
                {text: this.$options.filters.translate('Config Name'), value: 'config_name'},
                {text: this.$options.filters.translate('Facility Name'), value: 'facility_name'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            config: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        ...mapGetters([
            'apiBaseURL','siteConfigChildren','publishedCustomViews'
        ]),
        frontendVersion() {
            return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : null
        }
    },
    methods: {
        async runSyncToChildren(){
            let listOfChildren= this.siteConfigChildren.split(",")
            if (this.thingsToSync.length>0&&listOfChildren.length>0){
                this.syncInProgress=true
                this.syncProgress=0
                this.syncMessage=null
                let progressStep=100/(this.thingsToSync.length*listOfChildren.length)
                let rules=[]
                if (this.thingsToSync.includes("rules")){
                    rules = await getRule({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name
                    })
                }
                for (let childApiUrl of listOfChildren){
                    let remoteFacilities = await getFacilityList(
                        {
                            apiBaseUrl: childApiUrl
                        }
                    )
                    let remoteConfig = await getConfig(
                        {
                            apiBaseUrl: childApiUrl,
                            facility_name:remoteFacilities.facilities[0].facility_name
                        }
                    )
                    for (let configSyncName of ["menuConfig","mappingIntegrityConfig","mappingCalculatedConfig","mappingRefConfig","hiddenPointsConfig"]){
                        if (this.thingsToSync.includes(configSyncName)){
                            for (let item of this.config){
                                if (item.config_name===configSyncName){
                                    this.syncMessage="Syncing config "+configSyncName+" to "+remoteFacilities.facilities[0].facility_name
                                    let payload = {
                                        'config_id': null,
                                        'config_name': configSyncName,
                                        'facility_name': remoteFacilities.facilities[0].facility_name,
                                        'config': item.config,
                                        'apiBaseUrl': childApiUrl
                                    }
                                    for (let cfRec of remoteConfig.result) {
                                        if (cfRec.config_name === configSyncName) {
                                            payload.config_id = cfRec.config_id
                                        }
                                    }
                                    await putConfig(payload)
                                    this.syncProgress+=progressStep
                                    break
                                }
                            }
                        }
                    }
                    if (this.thingsToSync.includes("customViews")){
                        this.syncMessage="Syncing custom views to "+remoteFacilities.facilities[0].facility_name
                        let cvs=JSON.parse(JSON.stringify(this.publishedCustomViews))
                        for (let view of cvs){
                            view.facility = remoteFacilities.facilities[0].facility_name
                            view.published = true
                            view.lastUpdated=moment().format('YYYY-MM-DD HH:mm:ss')
                            await putCustomView({
                                view_id:view.id,
                                published:true,
                                json:view,
                                apiBaseUrl: childApiUrl
                            })
                        }
                        this.syncProgress+=progressStep
                    }
                    if (this.thingsToSync.includes("rules")){
                        this.syncMessage="Syncing rules to "+remoteFacilities.facilities[0].facility_name
                        let newRules=JSON.parse(JSON.stringify(rules.result))
                        for (let rule of newRules){
                            rule.facility_name = remoteFacilities.facilities[0].facility_name
                            rule.apiBaseUrl= childApiUrl
                            await putRule(rule)
                        }
                        this.syncProgress+=progressStep
                    }
                }
                this.syncDialog=false
                this.syncInProgress=false
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Sync complete')})
            }
        },
        initialize() {
            this.refresh()
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteConfig({
                    'config_id': item.config_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getConfig({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.config = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
